import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function CustomMenu({
    buttonLabel = 'Menu',
    menuItems = [],
    onMenuItemClick,
    buttonProps = {},
    menuProps = {},
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (item, index) => {
        if (onMenuItemClick) onMenuItemClick(item, index);
        handleClose();
    };

    return (
        <div>
            <Button
                id="custom-menu-button"
                aria-controls={open ? 'custom-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                {...buttonProps}
            >
                {buttonLabel}
            </Button>
            <Menu
                id="custom-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'custom-menu-button',
                    },
                }}
                {...menuProps}
            >
                {menuItems.map((item, idx) => (
                    <MenuItem key={idx} onClick={() => handleItemClick(item, idx)}>
                        {typeof item === 'string' ? item : item.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
